module.exports = __webpack_public_path__ + "static/media/wangzulan.6c438421.png";